import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { RepoService } from "../shared/services/repo.service";
import { UUID } from "angular2-uuid";
import { IndividualHealth } from "../shared/classes/individualHealthModel";
import { ngxLoadingAnimationTypes, NgxLoadingComponent } from "ngx-loading";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticateService } from "../shared/services/authenticate.service";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { CognitoService } from "src/app/shared/services/cognito.service";
import { CropsService } from "../shared/services/crops.service";
import { ProfileService } from "src/app/shared/services/profile.service";
import { EcommerceService } from "src/app/shared/services/ecommerce.service";
import { FileUploadService } from "../shared/services/fileupload.service";
import { TokenStorageService } from "../shared/services/token.service";
@Component({
  selector: "app-health-library",
  templateUrl: "./health-library.component.html",
  styleUrls: ["./health-library.component.sass"],
})
export class HealthLibraryComponent implements OnInit {
  @ViewChild("ngxLoading") ngxLoadingComponent: NgxLoadingComponent;
  @ViewChild("customLoadingTemplate") customLoadingTemplate: TemplateRef<any>;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;

  heading = "Health Library";
  @Input() cropname: string;
  @Input() maincropId: string;
  @Output() valueChange = new EventEmitter();
  groupName: string;
  cropArray: any = [];
  loading: boolean;
  showLibrary: boolean;
  cropNameList: any[];
  globalImgUrl: string;
  pageHealth = 1;
  pageResidue = 1;
  page = 1;
  crop: any;
  healthArray = [];
  index: any;
  healthObj: {
    cropName: string;
    name: string;
    description: string;
    profileType: string;
    recommendations: any[];
    recommLow: any;
    recommMedium: any;
    recommHigh: any;
    healthId: string;
    images: any[];
    group: string;
  };
  rec: any;
  type: string;
  urls = [];
  showList: boolean;
  healthDiagnosisFormGroup: FormGroup;
  showHealth: boolean = false;
  imageNameList: any[];
  rlobj: any = {};
  rmobj: any = {};
  rhobj: any = {};
  productLowArray = [];
  showMedDiv: boolean = false;
  imageUploadService: string;
  recommLowNote: string;
  recommMedNote: string;
  recommHighNote: string;
  individualHealth: IndividualHealth;
  showlowDiv: boolean = false;
  productMedArray = [];
  productHighArray = [];
  showMediumDiv: boolean = false;
  showHighDiv: boolean = false;
  productDataArray = [];
  showonebutton: boolean = false;
  showform: boolean;
  dropLow: boolean = false;
  showsecbutton: boolean;
  dropMedium: boolean = false;
  showthirdbutton: boolean;
  submitType: string = "save";
  uploadFileList: any = [];
  uploadMultipleFiles: any = [];
  btnLoading: boolean = false;
  previousPage: number;
  skip: number;
  collectionSize: number;
  healthpreviousPage: number;
  residuePreviousPage: number;
  healthskip: number;
  residueSkip: number;
  collectionSizeHealth: any;
  residueSize: any;
  searchStr: string = "";
  showsearchdata: boolean = true;
  prodIndex: number;
  diseaseArray: any = [];
  pagemaincropId: string = "";
  selectedProductId: any;
  selectedProduct: any;
  product: any = "";
  pesticideResidueData = [];
  showExportResidueData: boolean = false;
  tempData: any[];
  healthRecommArray: any[];
  showRecommendations: boolean = false;
  showDetails: boolean = false;
  selectedRecord: any;
  record: any;
  tableIndex: number;
  healthList = [];
  recordToEdit: any;
  selectedUuid: any;
  exportCount: number;

  constructor(
    private _formBuilder: FormBuilder,
    private authService: AuthenticateService,
    private tokenService: TokenStorageService,
    private profileService: ProfileService,
    private modalService: NgbModal,
    private cropsService: CropsService,
    private ecommerceService: EcommerceService,
    private cogService: CognitoService,
    private fileUploadService: FileUploadService
  ) {}

  ngDoCheck() {
    if (!this.globalImgUrl) {
      this.globalImgUrl = this.authService.s3url();
    }
    if (!this.groupName) {
      this.groupName = this.tokenService.getGroup();
      if (this.groupName) {
        if (this.cropname != undefined) {
          this.addHealthDiagnosis();
          // this.showHealth = true;
          // this.gethealthByCrop(this.cropname, this.maincropId);
          // this.healthObj.cropName = this.cropname;
        } else {
          this.getAllCrops();
        }
        this.getAllProducts();
        this.getExportData();
      }
    }
  }
  showExportResidue() {
    this.showExportResidueData = true;
    this.showHealth = false;
  }
  backToHealth() {
    this.showHealth = !this.showHealth;
    this.showExportResidueData = !this.showExportResidueData;
  }
  // getExportData() {
  //     this.pageResidue = 1;
  //     this.pesticideResidueData = [];
  //     this.profileService.getExportResidueData().then((data: any) => {
  //         if (data.length > 0) {
  //             this.pesticideResidueData = data;
  //             this.residueSize = data.length;
  //             console.log("@@Pesticide residue data:",this.pesticideResidueData)
  //         }
  //     })
  // }
  getExportData() {
    this.tempData = [];
    this.loading = true;
    var options = {
      limit: 20,
      skip: 0,
    };
    // this.ecommerceService.getMangoExportsResidueData({}).then((data: any) => {
    let data = this.pesticideResidueData;
    console.log("@@Pesticide residue data:", this.pesticideResidueData);
    if (data.length > 0) {
      this.pesticideResidueData = data;
      this.tempData = this.pesticideResidueData.slice(0, 20);
      this.loading = false;
    } else {
      this.loading = false;
    }
    // });
    this.ecommerceService.getMangoExportsResidueCount({}).then((data: any) => {
      if (data) {
        this.residueSize = data.data;
      }
    });
  }
  ngOnInit() {
    this.pesticideResidueData = require("../shared/definedJsons/exportCompliance.json");
    this.residueSize = this.pesticideResidueData.length;
    console.log(
      "@@Pesticide residue data:",
      this.pesticideResidueData,
      "@@residue size:",
      this.residueSize
    );
    this.groupName = this.tokenService.getGroup();
    if (!this.globalImgUrl) {
      this.globalImgUrl = this.authService.s3url();
    }
    if (this.cropname != undefined) {
      this.addHealthDiagnosis();
    } else {
      this.getAllCrops();
    }
    this.getAllProducts();
    this.getExportData();
    console.log("cropname ", this.cropname, this.maincropId);
    this.loading = true;
    this.healthArray = [];
    this.urls = [];
    this.imageNameList = [];
    this.crop = "";
    this.healthDiagnosisFormGroup = this._formBuilder.group({
      name: ["", Validators.required],
      cropName: ["", Validators.required],
      description: ["", Validators.required],
      profileType: ["", Validators.required],
      lproductName: [""],
      ldosage: [""],
      lapplication: [""],
      mproductName: [""],
      mdosage: [""],
      mapplication: [""],
      hproductName: [""],
      hdosage: [""],
      happlication: [""],
    });
  }

  config = {
    displayKey: "technicalName", // if objects array passed which key to be displayed defaults to description
    search: true,
    limitTo: 10,
    height: "225px",
  };

  getAllCrops() {
    this.pageHealth = 1;
    this.showsearchdata = true;
    this.cropNameList = [];
    this.cropArray = [];
    var options = {
      group: this.groupName,
      // options: {
      limit: 20,
      // sortFields: { createTs: -1 },
      skip: 0,
      // },
    };
    this.cropsService.getCropData(options).then((data: any) => {
      // console.log("getAllCrops == ", data);
      this.loading = false;
      this.showLibrary = true;
      if (data.length > 0) {
        this.cropArray = data;
        for (var i = 0; i < data.length; i++) {
          this.cropNameList.push(data[i].cropName);
        }
      } else {
        this.loading = false;
      }
    });
    var count = { group: this.groupName };
    this.cropsService.getCropscount(count).then((data: any) => {
      // console.log("COUNT : ", data);
      if (data.length > 0) {
        this.collectionSizeHealth = data[0].size;
      }
    });
  }

  loadHealthpage(pageNumber: number) {
    this.loading = true;
    // console.log("page number ", pageNumber, this.healthpreviousPage)
    if (pageNumber !== this.healthpreviousPage) {
      this.healthskip = pageNumber * 20 - 20;
      // console.log("this.healthskip", this.healthskip)
      this.healthpreviousPage = pageNumber;
      // console.log("this.previousPage", this.previousPage)
      this.loadHealthData(this.healthskip);
    }
  }

  loadHealthData(healthskip) {
    this.cropNameList = [];
    this.cropArray = [];
    var count = { group: this.groupName };
    this.showLibrary = true;
    this.showHealth = false;
    var options = {
      group: this.groupName,
      // options: {
      limit: 20,
      // sortFields: { createTs: -1 },
      skip: healthskip,
      // },
    };
    this.cropsService.getCropData(options).then((data: any) => {
      // console.log("getAllCrops : ", data);
      if (data.length > 0) {
        this.cropArray = data;
        this.loading = false;
      } else {
        this.loading = false;
      }
    });
    this.cropsService.getCropscount(count).then((data: any) => {
      // console.log("health size : ", data)
      if (data.length > 0) {
        this.collectionSizeHealth = data[0].size;
        // console.log("collectionSizeHealth....", this.collectionSizeHealth)
      }
    });
  }
  loadResiduePage(pageNumber: number) {
    this.loading = true;
    console.log("page number ", pageNumber, this.residuePreviousPage);
    if (pageNumber !== this.residuePreviousPage) {
      this.residueSkip = pageNumber * 20 - 20;
      console.log("this.residueSkip", this.residueSkip);
      this.residuePreviousPage = pageNumber;
      console.log("this.residuePreviousPage", this.residuePreviousPage);
      this.loadResidueData(this.residueSkip);
    }
  }

  loadResidueData(residueSkip) {
    // this.pesticideResidueData = this.profileService.getResidueData();
    this.pesticideResidueData = require("../shared/definedJsons/exportCompliance.json");
    console.log("@@pesticideResidueData data:", this.pesticideResidueData);
    this.tempData = this.pesticideResidueData.splice(residueSkip, 20);
    this.loading = false;
    console.log("@@Temp data:", this.tempData);
  }

  loadPage(pageNumber: number) {
    this.loading = true;
    // console.log("page number ", pageNumber, this.previousPage)
    if (pageNumber !== this.previousPage) {
      this.skip = pageNumber * 15 - 15;
      // console.log("this.skip", this.skip)
      this.previousPage = pageNumber;
      // console.log("this.previousPage", this.previousPage)
      this.loadData(this.skip);
    }
  }

  loadData(skip) {
    let mainId =
      this.cropname != undefined ? this.maincropId : this.pagemaincropId;
    this.loading = true;
    this.healthArray = [];
    var options = {
      group: this.groupName,
      maincropId: mainId,
      // options: {
      limit: 15,
      // sortFields: { createTs: -1 },
      skip: skip,
      // },
    };
    console.log("options", options);
    this.profileService.getHealthLib(options).then((data: any) => {
      // console.log("getAllHealthLib : ", data);
      if (data.length > 0) {
        this.healthArray = data;
        this.loading = false;
      } else {
        this.loading = false;
      }
    });
    var count = { group: this.groupName, maincropId: mainId };
    // console.log("count", count)
    this.profileService.getHealthCount(count).then((data: any) => {
      // console.log("health size : ", data)
      if (data.length > 0) {
        this.collectionSize = data[0].size;
        // console.log("collectionsize....", this.collectionSize)
      }
    });
  }

  gethealthByCrop(crop, mainCropId, value) {
    this.crop = crop;
    this.showsearchdata = true;
    this.pagemaincropId = mainCropId;
    this.loading = true;
    this.healthArray = [];
    this.showLibrary = false;
    this.showHealth = value;
    this.page = 1;
    this.previousPage = 0;
    var options = {
      group: this.groupName,
      maincropId: mainCropId,
      // options: {
      limit: 15,
      // sortFields: { createTs: -1 },
      skip: 0,
      // },
    };
    console.log("options : ", options);
    // this.healthArray = [];
    this.profileService.getHealthLib(options).then((data: any) => {
      console.log("cropData == ", data);
      // this.showLibrary = false;
      // this.showHealth = true;
      if (data.length > 0) {
        this.healthArray = data;
        console.log("varietyarray", this.healthArray);
        this.loading = false;
      } else {
        this.loading = false;
      }
    });
    var count = { group: this.groupName, maincropId: mainCropId };
    console.log("countObj : ", count);
    this.profileService.getHealthCount(count).then((data: any) => {
      console.log("COUNT : ", data);
      if (data.length > 0) {
        this.collectionSize = data[0].size;
      } else {
        this.loading = false;
      }
    });
  }
  openmodal(form, type, data, i) {
    this.product = "";
    console.log("data ", data, " type ", type, i);
    if (i != undefined) this.prodIndex = i;
    else this.prodIndex = undefined;
    let config: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
      size: "lg",
    };
    if (data == undefined) {
      this.submitType = "save";
    } else {
      this.submitType = "update";
    }
    if (type == "low" && data == undefined) {
      this.rlobj = {
        product: "",
        dosage: "",
        productuuid: "",
      };
      // this.productLowArray.push(this.rlobj)
    } else if (type == "medium" && data == undefined) {
      this.rmobj = {
        product: "",
        dosage: "",
        productuuid: "",
      };
      // this.productMedArray.push(this.rmobj)
    } else if (type == "high" && data == undefined) {
      this.rhobj = {
        product: "",
        dosage: "",
        productuuid: "",
      };
      // this.productHighArray.push(this.rhobj)
    }
    if (data && type == "low") {
      this.rlobj = JSON.parse(JSON.stringify(data));
      // console.log("@@Product low array && data:", this.rlobj);
    } else if (data && type == "medium") {
      this.rmobj = JSON.parse(JSON.stringify(data));
      // console.log("@@Product medium array in data::", this.rmobj);
    } else if (data && type == "high") {
      this.rhobj = JSON.parse(JSON.stringify(data));
      // console.log("@@Product high array in data:", this.rhobj);
    }
    this.modalService.open(form, config);
  }

  closeModal(type) {
    this.prodIndex = undefined;
    if (this.submitType == "save") {
      if (type == "low") {
        this.productLowArray.pop();
      } else if (type == "medium") {
        this.productMedArray.pop();
      } else if (type == "high") {
        this.productHighArray.pop();
      }
    }
  }
  editData(index, profileType) {
    this.type = "update";
    this.cropNameList = [];
    this.uploadFileList = [];
    this.showList = true;
    this.showLibrary = false;
    this.showHealth = false;
    this.urls = [];
    this.imageNameList = [];
    this.productHighArray = [];
    this.productLowArray = [];
    this.productMedArray = [];
    this.recommMedNote = "";
    this.recommLowNote = "";
    this.recommHighNote = "";
    this.index = index;
    console.log("cropdata edited", this.healthArray[index]);
    this.healthObj = this.healthArray[index];
    let rec = this.healthArray[index].recommendations.find(
      (item) => item.type == profileType
    );
    this.selectedUuid = rec.uuid;
    this.healthObj.profileType = rec.type;
    this.recordToEdit = rec.value;
    console.log("@@Health object profile type:", this.healthObj.profileType);
    if (this.recordToEdit[0].recommLow.products) {
      this.productLowArray = this.recordToEdit[0].recommLow.products;
      // console.log("@@Product low array in edit data:",this.productLowArray)
    }
    if (this.recordToEdit[0].recommLow.application) {
      this.recommLowNote = this.recordToEdit[0].recommLow.application;
    }
    if (this.recordToEdit[1].recommMedium.products) {
      this.productMedArray = this.recordToEdit[1].recommMedium.products;
      // console.log("@@Product Med array in edit data:",this.productMedArray)
    }
    if (this.recordToEdit[1].recommMedium.application) {
      this.recommMedNote = this.recordToEdit[1].recommMedium.application;
    }
    if (this.recordToEdit[2].recommHigh.products) {
      this.productHighArray = this.recordToEdit[2].recommHigh.products;
      // console.log("@@Product High array in edit data:",this.productHighArray)
    }
    if (this.recordToEdit[2].recommHigh.application) {
      this.recommHighNote = this.recordToEdit[2].recommHigh.application;
    }
    this.cropNameList.push(this.healthArray[index].cropName);
    // console.log("nn : ", this.healthObj);
    this.imageNameList = this.healthArray[index].images;
    this.showRecommendations = true;
    for (var i = 0; i < this.healthArray[index].images.length; i++) {
      console.log("images : ", this.healthArray[index].images[i]);
      this.urls.push(this.globalImgUrl + this.healthArray[index].images[i]);
      this.uploadFileList.push(
        this.globalImgUrl + this.healthArray[index].images[i]
      );
    }
    // console.log(this.productHighArray)
  }

  deleteproduct(index, type) {
    console.log("Deleteproduct:-", index, type);
    if (type == "low") {
      this.productLowArray.splice(index, 1);
    } else if (type == "medium") {
      this.productMedArray.splice(index, 1);
    } else if (type == "high") {
      this.productHighArray.splice(index, 1);
    }
  }

  back() {
    if (this.cropname != undefined) {
      this.valueChange.emit();
    }
    this.showHealth = true;
    this.showList = false;
    this.gethealthByCrop(this.crop, this.pagemaincropId, true);
    this.healthDiagnosisFormGroup.reset();
  }

  backtoCrop() {
    this.showHealth = false;
    this.showLibrary = true;
    this.showsearchdata = true;
    this.imageNameList = [];
    this.urls = [];
    this.collectionSizeHealth = 0;
    this.residueSize = 0;
    this.collectionSize = 0;
    this.cropArray = [];
    this.getAllCrops();
  }
  handleInput(e) {
    if (e.which === 32 && e.target.selectionStart === 0) {
      return false;
    }
  }

  onImgError(event) {
    event.target.src = this.globalImgUrl + "agri_logo.png";
  }

  getAllProducts() {
    this.productDataArray = [];
    let obj = {
      group: this.groupName,
    };
    this.profileService.getAllProducts(obj).then((data: any) => {
      for (var i = 0; i < data.length; i++) {
        let obj = {
          technicalName: data[i].technicalName,
          // tradeName: data[i].tradeName,
          productuuid: data[i].productuuId,
        };
        // this.productDataArray.push(data[i].technicalName)
        this.productDataArray.push(obj);
      }
    });
  }
  onProductChange(e, type) {
    this.selectedProductId = e.productuuid;
    this.selectedProduct = e.technicalName;
    if (type == "low") {
      this.rlobj = {
        product: this.selectedProduct,
        productuuid: this.selectedProductId,
        dosage: this.rlobj.dosage ? this.rlobj.dosage : "",
      };
    } else if (type == "medium") {
      this.rmobj = {
        product: this.selectedProduct,
        productuuid: this.selectedProductId,
        dosage: this.rhobj.dosage ? this.rhobj.dosage : "",
      };
    } else if (type == "high") {
      this.rhobj = {
        product: this.selectedProduct,
        productuuid: this.selectedProductId,
        dosage: this.rhobj.dosage ? this.rhobj.dosage : "",
      };
    }
  }
  addProductArr(type) {
    console.log("SAVE : ", type, "@Prod index:", this.prodIndex);
    console.log("SAVE  : this.productLowArray", this.productLowArray);
    console.log(
      "SAVE  : this.rlobj",
      this.rlobj,
      "this.rmobj",
      this.rmobj,
      "this.rhobj",
      this.rhobj
    );
    if (type == "low") {
      if (this.prodIndex != undefined) {
        this.productLowArray[this.prodIndex] = this.rlobj;
      } else {
        this.productLowArray.push(this.rlobj);
      }
      this.healthObj.recommLow = {
        products: this.productLowArray,
        application: this.recommLowNote,
      };
      console.log("lowww in adding", JSON.stringify(this.healthObj.recommLow));
    }
    if (type == "medium") {
      if (this.prodIndex != undefined) {
        this.productMedArray[this.prodIndex] = this.rmobj;
      } else {
        this.productMedArray.push(this.rmobj);
      }
      this.healthObj.recommMedium = {
        products: this.productMedArray,
        application: this.recommMedNote,
      };
      console.log("meddd", JSON.stringify(this.healthObj.recommMedium));
    }
    if (type == "high") {
      if (this.prodIndex != undefined) {
        this.productHighArray[this.prodIndex] = this.rhobj;
      } else {
        this.productHighArray.push(this.rhobj);
      }
      this.healthObj.recommHigh = {
        products: this.productHighArray,
        application: this.recommHighNote,
      };
      console.log("highhhh", JSON.stringify(this.healthObj.recommHigh));
    }
  }

  addHealthDiagnosis() {
    this.btnLoading = false;
    this.loading = false;
    this.showList = true;
    this.showHealth = false;
    this.type = "save";
    this.urls = [];
    this.imageNameList = [];
    this.healthObj = {
      cropName: "",
      name: "",
      description: "",
      profileType: "",
      recommendations: [],
      recommLow: {},
      recommMedium: {},
      recommHigh: {},
      healthId: "",
      images: [],
      group: "",
    };
    if (this.cropname != undefined) {
      this.healthObj.cropName = this.cropname;
      this.healthObj["maincropId"] = this.maincropId;
    } else {
      this.healthObj.cropName = this.crop;
      this.healthObj["maincropId"] = this.pagemaincropId;
    }
    this.recommHighNote = "";
    this.recommLowNote = "";
    this.recommMedNote = "";
    this.productLowArray = [];
    this.productMedArray = [];
    this.productHighArray = [];
  }

  uploadFileToActivity() {
    for (var i = 0; i < this.uploadMultipleFiles.length; i++) {
      // console.log(
      //   "@@form data in upload multiple files:",
      //   this.uploadMultipleFiles[i].get("file")
      // );
      // console.log(
      //   "@@upload multiple files in health library:",
      //   this.uploadFileList[i]
      // );
      console.log(
        "@@Upload multiple files:",
        this.uploadMultipleFiles,
        this.imageUploadService
      );
      this.fileUploadService.uploadMultipleFiles(
        this.uploadMultipleFiles[i],
        this.imageUploadService
      );
    }
  }

  imageInput(event) {
    if (event.target.files && event.target.files[0]) {
      var fileLength = event.target.files.length;
      for (let i = 0; i < fileLength; i++) {
        if (event.target.files[i].type.split("/")[0] == "image") {
          var reader = new FileReader();
          reader.onload = (event: any) => {
            this.urls.push(event.target.result);
          };
          reader.readAsDataURL(event.target.files[i]);
          let iuuid = UUID.UUID();
          this.imageUploadService =
            "var_" +
            iuuid +
            "." +
            event.target.files.item(0).type.split("/")[1];
          this.imageNameList.push(this.imageUploadService);
          const formData: FormData = new FormData();
          formData.set("file", event.target.files[i], this.imageUploadService);
          formData.append("name", this.imageUploadService);
          this.uploadFileList.push(formData);
          this.uploadMultipleFiles.push(formData);
          console.log(
            "@@Upload multiple files:",
            this.uploadMultipleFiles,
            this.imageUploadService
          );
          // for(var pair of data.entries()) {
          //     console.log(pair[0]+ ', '+ pair[1]);
          //  }
        }
      }
    }
  }
  openModel(RecommendationDetails, rec) {
    this.selectedRecord = rec.value;
    console.log("@@Selected record", this.selectedRecord);
    let config: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
    };
    this.modalService.open(RecommendationDetails, config);
  }
  closeUpdate() {
    this.showList = false;
  }
  backtoHealth() {
    this.showDetails = false;
    this.showHealth = true;
  }
  openEditModel(EditRecommendationDetails, rec) {
    console.log("@@Health list:", this.healthList);
    this.record = rec;
    let config: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
    };
    this.modalService.open(EditRecommendationDetails, config);
    this.editData(this.tableIndex, rec.type);
  }
  saveRecommendation() {
    this.healthRecommArray = [];
    this.healthObj.recommLow = {
      products: this.productLowArray,
      application: this.recommLowNote,
    };
    this.healthObj.recommMedium = {
      products: this.productMedArray,
      application: this.recommMedNote,
    };
    this.healthObj.recommHigh = {
      products: this.productHighArray,
      application: this.recommHighNote,
    };
    if (this.healthObj.recommLow) {
      this.healthRecommArray.push({ recommLow: this.healthObj.recommLow });
    }
    if (this.healthObj.recommMedium) {
      this.healthRecommArray.push({
        recommMedium: this.healthObj.recommMedium,
      });
    }
    if (this.healthObj.recommHigh) {
      this.healthRecommArray.push({ recommHigh: this.healthObj.recommHigh });
    }
    if (this.healthRecommArray) {
      let recommendationObj = {
        uuid: UUID.UUID(),
        type: this.healthObj.profileType,
        value: this.healthRecommArray,
      };
      this.healthObj["recommendations"].push(recommendationObj);
    }
    console.log("@@Save recommendation:", this.healthObj);
    this.showRecommendations = false;
  }
  viewDetails(index) {
    console.log("@@view clicked:", this.healthArray[index]);
    this.healthList = [];
    this.showHealth = !this.showHealth;
    // this.showExportResidueData = !this.showExportResidueData;
    this.diseaseArray = [];
    this.tableIndex = index;
    this.healthList = this.healthArray[index];
    this.diseaseArray = this.healthArray[index].recommendations;
    console.log("@@Diseases array:", this.diseaseArray);
    this.showDetails = true;
  }
  onChangeProfileType(event) {
    this.showRecommendations = true;
    console.log("@@On change profile type:", event);
    this.healthObj.recommHigh = {};
    this.healthObj.recommLow = {};
    this.healthObj.recommMedium = {};
    this.recommHighNote = "";
    this.recommLowNote = "";
    this.recommMedNote = "";
    this.productLowArray = [];
    this.productMedArray = [];
    this.productHighArray = [];
  }
  submitHealth() {
    this.btnLoading = true;
    this.healthObj.healthId = UUID.UUID();
    this.healthObj.images = this.imageNameList;
    if (this.recommLowNote) {
      this.healthObj.recommLow["application"] = this.recommLowNote;
    }
    if (this.recommMedNote) {
      this.healthObj.recommMedium["application"] = this.recommMedNote;
    }
    if (this.recommHighNote) {
      this.healthObj.recommHigh["application"] = this.recommHighNote;
    }
    this.healthObj.group = this.groupName;
    delete this.healthObj.recommHigh;
    delete this.healthObj.recommLow;
    delete this.healthObj.recommMedium;
    delete this.healthObj.profileType;
    this.individualHealth = this.healthObj;
    if (this.healthObj.images.length != 0) {
      this.loading = true;
      this.uploadFileToActivity();
      this.profileService
        .postHealthdiagnosis(this.individualHealth)
        .then((data: any) => {
          this.valueChange.emit();
          console.log("healthfinal data", data);
          this.btnLoading = false;
          if (data) {
            this.showList = false;
            this.healthDiagnosisFormGroup.reset();
            this.imageNameList = [];
            this.urls = [];
            this.uploadFileList = [];
            Swal({ title: "Health data saved successfully!" });
            if (this.cropname != undefined) {
              // this.gethealthByCrop(this.cropname, this.maincropId);
            } else {
              this.showHealth = true;
              this.gethealthByCrop(this.crop, this.pagemaincropId, true);
            }
          } else {
            this.btnLoading = false;
            Swal.fire(
              "Error",
              "Data not Submitted (please contact admin)",
              "error"
            );
          }
        });
    } else {
      this.btnLoading = false;
      Swal.fire("Error", "Please upload images", "error");
    }
  }

  updateData() {
    this.btnLoading = true;
    console.log("health object ", this.healthObj, this.imageNameList);
    this.healthObj.images = this.healthObj.images.concat(
      this.imageNameList.filter((item) => {
        return this.healthObj.images.indexOf(item) < 0;
      })
    );
    if (
      this.healthObj.recommMedium ||
      this.healthObj.recommLow ||
      this.healthObj.recommHigh
    ) {
      this.rec = this.healthObj.recommendations.find(
        (item) => item.uuid == this.selectedUuid
      );
      console.log("@@Final record to be updated:", this.rec);
    }
    for (
      let index = 0;
      index < this.healthObj.recommendations.length;
      index++
    ) {
      if (this.healthObj.recommendations[index].uuid == this.selectedUuid) {
        if (this.healthObj.recommMedium != undefined) {
          this.healthObj.recommendations[index].value[1].recommMedium =
            this.rec.value[1].recommMedium;
        }
        if (this.recommMedNote) {
          this.healthObj.recommendations[index].value[1].recommMedium[
            "application"
          ] = this.recommMedNote;
        }
        if (this.healthObj.recommLow) {
          this.healthObj.recommendations[index].value[0].recommLow =
            this.rec.value[0].recommLow;
        }
        if (this.recommLowNote) {
          this.healthObj.recommendations[index].value[0].recommLow[
            "application"
          ] = this.recommLowNote;
        }
        if (this.healthObj.recommHigh) {
          this.healthObj.recommendations[index].value[2].recommHigh =
            this.rec.value[2].recommHigh;
        }
        if (this.recommHighNote) {
          this.healthObj.recommendations[index].value[2].recommHigh[
            "application"
          ] = this.recommHighNote;
        }
      }
    }
    console.log("@@Health obj after insertion:", this.healthObj);
    console.log("this.cobj.cropImages ", this.healthObj.images);
    // this.healthObj.images = this.healthObj.images.concat(this.imageNameList);
    this.healthObj.group = this.groupName;
    if (this.healthObj.recommMedium) delete this.healthObj.recommMedium;
    if (this.healthObj.recommHigh) delete this.healthObj.recommHigh;
    if (this.healthObj.recommLow) delete this.healthObj.recommLow;
    if (this.healthObj.profileType) delete this.healthObj.profileType;
    console.log("@@Final Health obj after insertion:", this.healthObj);
    this.individualHealth = this.healthObj;
    if (this.healthObj.images.length != 0) {
      if (this.imageUploadService && this.imageUploadService.length > 0) {
        this.uploadFileToActivity();
      }
      this.loading = true;
      delete this.healthObj["_id"];
      console.log("healthobj", JSON.stringify(this.individualHealth));
      this.profileService.updateHealth(this.healthObj).then((data: any) => {
        console.log("updateCropVariety data == ", JSON.stringify(data));
        this.btnLoading = false;
        if (data) {
          this.gethealthByCrop(this.crop, this.pagemaincropId, false);
          this.showList = false;
          this.healthDiagnosisFormGroup.reset();
          this.imageNameList = [];
          this.uploadFileList = [];
          this.urls = [];
          // this.showHealth = true;
          this.showDetails = true;
          this.loading = false;
          Swal({ title: "Health data Updated successfully!" });
        } else {
          this.loading = false;
          // this.showList = true;
          this.btnLoading = false;
          Swal.fire(
            "Error",
            "Data not Submitted (please contact admin) or submit again",
            "error"
          );
        }
      });
    } else {
      this.btnLoading = false;
      Swal.fire("Error", "Please upload images", "error");
    }
  }

  searchByName() {
    if (this.searchStr != "") {
      var obj = {
        group: this.groupName,
        field: "cropName",
        text: this.searchStr,
        tableName: "cropdata",
      };
      console.log("search obj : ", obj);
      this.cropsService.getCropRegex(obj).then((data: any) => {
        console.log("searched", data);
        this.cropArray = [];
        this.searchStr = "";
        if (data.length > 0) {
          this.cropArray = data;
          this.showsearchdata = false;
          console.log("varietyArray", this.cropArray);
        } else {
          this.showsearchdata = false;
        }
      });
    }
  }

  searchByDisease() {
    if (this.searchStr != "") {
      var obj = {
        group: this.groupName,
        text: this.searchStr,
        tableName: "healthLib",
        field: "name",
        query: {
          maincropId: this.pagemaincropId,
        },
      };
      console.log("search obj : ", obj);
      this.profileService.getHealthRegex(obj).then((data: any) => {
        console.log("searched", data);
        this.healthArray = [];
        this.searchStr = "";
        if (data.length > 0) {
          this.healthArray = data;
          this.showsearchdata = false;
          console.log("healthArray", this.healthArray);
        } else {
          this.showsearchdata = false;
        }
      });
    }
  }

  deleteImage(index) {
    this.imageNameList.splice(index, 1);
    this.urls.splice(index, 1);
    if (this.uploadFileList.length > 0) {
      this.uploadFileList.splice(index, 1);
    }
    console.log("deleteImage ", this.imageNameList, event);
  }
}
